import type { DateTime } from 'luxon'

import type { OneTimeAcknowledgement } from '@/queries/constants'

import useOneTimeAcknowledgements from './useOneTimeAcknowledgements'

/**
 * NOTE: This function does not return a stable return value. It's useless using the value
 * in a hook dependency.
 */
export default function useOneTimeAcknowledgement(
  key: OneTimeAcknowledgement,
  options: { disableRefresh?: boolean } = {}
): {
  acknowledgedAt: DateTime | null
  onAcknowledgement: () => Promise<void>
} {
  const [acknowledgement] = useOneTimeAcknowledgements([key], options)
  return acknowledgement
}
